import type { AxiosError } from 'axios'

// Only the `{ message, exception, … }` envelope the gateway services behind the
// "Need Help?" lookups return. Anything else falls through to null so the
// caller shows its own copy rather than leaking a half-recognised body.
type GatewayErrorBody = {
  message?: unknown
}

export const getApiErrorMessage = (error: unknown): string | null => {
  const message = (error as AxiosError<GatewayErrorBody> | null | undefined)
    ?.response?.data?.message

  return typeof message === 'string' && message.trim() ? message.trim() : null
}
